import Badges from "../views/Badges/Badges";
import Login from "../views/Login/Login";
import Memberships from "../views/Memberships/Memberships";
import Promotions from "../views/Promotions/Promotions";
import Roles from "../views/Roles/Roles";
import Routes from "../views/Rutas/Routes";
import Specialist from "../views/Specialist/Specialist";
import Users from "../views/Users/Users";
import UsersAdmins from "../views/UsersAdmins/UsersAdmins";

export const routes = [
  {
    name: "auth",
    path: "/",
    Component: Login,
  },
];

export const profileRoutes = [
  {
    name: "Membresías",
    path: "memberships",
    Component: Memberships,
  },
  {
    name: "Usuarios",
    path: "users",
    Component: Users,
  },
  {
    name: "Especialistas",
    path: "specialist",
    Component: Specialist,
  },
  {
    name: "Administradores",
    path: "admins",
    Component: UsersAdmins,
  },
  {
    name: "Roles",
    path: "roles",
    Component: Roles,
  },
  {
    name: "Promociones",
    path: "offerts",
    Component: Promotions,
  },
  {
    name: "Logros",
    path: "badges",
    Component: Badges,
  },
  {
    name: "Routes",
    path: "routes",
    Component: Routes,
  },
];
